"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _conditionalComponent = require("@cian/conditional-component");
var _widgetContext = require("../../../context/widgetContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Базовая обертка для элементов в строке фильтров для десктопа
 * Решает задачи:
 *   * скругления у первого (левый край) и у последнего (правый край) фильтров
 *   * граница-разделитель между фильтрами
 * */
const FilterWrapper = props => {
  const {
    isLastFilter,
    isFirstFilter,
    children
  } = props;
  const {
    isDesktop,
    isMyHome
  } = React.useContext(_widgetContext.widgetContext);
  const isDesktopView = isDesktop && !isMyHome; // Для моего дома необхъодимо использовать мобильные компоненты

  return /*#__PURE__*/React.createElement(_conditionalComponent.ConditionalWrapper, {
    if: isDesktopView,
    thenRender: el => /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("div", {
      className: (0, _clsx.default)(styles['container'], {
        [styles['last']]: isLastFilter,
        [styles['first']]: isFirstFilter
      })
    }, el))
  }, children);
};
exports.FilterWrapper = FilterWrapper;